module.exports = __webpack_public_path__ + "static/img/icon-metodologia-4.e0217001.svg";